import { elementExist } from "../../../ground/assets/js/utilities/selector";
import isMobile from "ismobilejs";
import {
	initAlwaysRunScripts,
	initWoocommerceScripts,
} from "../../../ground/assets/js/functions";

function initAnimationScripts() {
	// HandleAnimation
	if (elementExist("[data-scroll]")) {
		import(
			/* webpackChunkName: "ground-handleAnimation" */ "./animations/handleAnimation"
		)
			.then((module) => {
				const HandleAnimation = module.default;
				new HandleAnimation();
			})
			.catch((error) => console.log(error));
	}

	// AnimationFlip
	if (elementExist("[data-flip]")) {
		import(
			/* webpackChunkName: "ground-animationFlip" */ "./animations/animationFlip"
		)
			.then((module) => {
				const AnimationFlip = module.default;
				new AnimationFlip();
			})
			.catch((error) => console.log(error));
	}
}

function initAlwaysRunScriptsChild() {
	// AnimationWebGl
	// if (elementExist('[data-scroll="js-webgl"]')) {
	// 	import(
	// 		/* webpackChunkName: "ground-animationWebGl" */ './webGl/animationWebGl'
	// 	)
	// 		.then((module) => {
	// 			const AnimationWebGl = module.default;
	// 			new AnimationWebGl();
	// 		})
	// 		.catch((error) => console.log(error));
	// }
	// JS Loader
	// import(/* webpackChunkName: "ground-loader" */ './components/loader')
	// 	.then((module) => {
	// 		const Loader = module.default;
	// 		new Loader();
	// 	})
	// 	.catch((error) => console.log(error));
	// Magnet
	// if (elementExist(".js-magnet")) {
	// 	import(/* webpackChunkName: "ground-magnet" */ "./components/magnetV2")
	// 		.then((module) => {
	// 			const Magnet = module.default;
	// 			new Magnet();
	// 		})
	// 		.catch((error) => console.log(error));
	// }
	// Cursor
	// if (elementExist(".js-cursor") && !isMobile().any) {
	// 	import(/* webpackChunkName: "ground-cursor" */ "./components/cursorV2")
	// 		.then((module) => {
	// 			const Cursor = module.default;
	// 			new Cursor();
	// 		})
	// 		.catch((error) => console.log(error));
	// }
}

function initSliderScriptChild() {
	// Slider
	if (elementExist(".js-slider")) {
		// In parent the import of the module fire an event
		// Always add the class .js-slider to let the parent import the module
		window.addEventListener("MODULE_SLIDER_LOADED", (module) => {
			const Slider = module.detail.default;

			if (elementExist(".js-carousel")) {
				new Slider(".js-carousel", {
					loop: false,
					autoHeight: false,
					effect: "slide",
					slidesPerView: 1,
					spaceBetween: 24,
					parallax: false,
					autoplay: false,
					freeMode: false,
					speed: 1000,
					touchEventsTarget: ".swiper-wrapper",
					pagination: {
						el: ".swiper-pagination",
						type: "progressbar",
					},
				});
			}

			if (
				elementExist(".js-swiperThumb") &&
				elementExist(".js-swiperGallery")
			) {
				var swiperThumb = new Slider(".js-swiperThumb", {
					spaceBetween: 10,
					watchSlidesProgress: true,
					centeredSlides: true, // Important! to get the active one in the middle
					loop: true,
					autoplay: false, // Important! Disable in one of the two related slider otherwise works double
					slidesPerView: "auto",
					slideToClickedSlide: true, // Set to true and click on any slide will produce transition to this slide
					loopedSlides: 4,
				});

				var swiperGallery = new Slider(".js-swiperGallery", {
					spaceBetween: 16,
					slidesPerView: 1,
					autoplay: false,
					loop: true,
					loopedSlides: 4,
					autoHeight: true,
				});

				swiperThumb.addControl(swiperGallery);
				swiperGallery.addControl(swiperThumb);
			}
		});
	}
}

function initParentScripts() {
	// Comment partials you don't need
	initAlwaysRunScripts();
	// initWoocommerceScripts();
}

function initCustomScripts() {
	// EventFilters
	if (elementExist(".js-event-filters") && !isMobile().any) {
		import(
			/* webpackChunkName: "ground-eventFilters" */ "./custom/eventFilters"
		)
			.then((module) => {
				const EventFilters = module.default;
				new EventFilters();
			})
			.catch((error) => console.log(error));
	}
}

export {
	initAnimationScripts,
	initAlwaysRunScriptsChild,
	initParentScripts,
	initSliderScriptChild,
	initCustomScripts,
};
